<template>

<router-link :to="'/jobs/' + row.id + '/general-settings'">{{ row.attributes.job_name }}</router-link>

</template>

<script>

export default {
    props: ['row']
}

</script>
